// extracted by mini-css-extract-plugin
export default {"homeTitle":"HomePage_homeTitle__MKDla"};